// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__QLgTT","paramInput":"JobSimulator_paramInput__z4qbj","input":"JobSimulator_input__2mN_n"};